<template>
	<footer>
		<div class="footer">
			<div class="footer-left">
				<div class="left-li" v-for="tit in foottit">
					<router-link :to = 'tit.vuelink'>
						<h4>{{tit.name}}</h4>
					</router-link>
				</div>	
			</div>
		</div>
		<div style="clear: both;"></div>
		<div class="footer-lines"></div>
		<div class="footer-bottom">
			<div class="bottom-left">
				<p style="line-height: 28px;">客服热线：0752-2286868 	传真：0752-2271612  地址：惠州市麦地华夏花园A2幢607、608房<br/>
Copyright    2017 惠州市惠航机电安装有限公司版权所有  <a href="http://www.beian.miit.gov.cn/">粤ICP备18016328号-1</a>  技术支持：思程科技</p>
			</div>
			<div class="bottom-right">
				<img src="../../static/img/footlogo.png">
			</div>
		</div>
	</footer>
</template>

<script>
	export default{
		name: 'footer',
		data (){
			return {
				foottit : [
				{id : 0 , name : '首页' , vuelink : '/'},
				{id : 1 , name : '公司简介' , vuelink : '/About/' },
				{id : 2 , name : '企业形象' , vuelink : '/Culture/'},
				{id : 3 , name : '工程案例' , vuelink : '/Engineering/'},
				{id : 4 , name : '服务承诺' , vuelink : '/Service/'},
				{id : 5 , name : '招贤纳士' , vuelink : '/Recruit/'},
				{id : 6 , name : '留言反馈' , vuelink : '/Feedback/'},
				{id : 7 , name : '联系我们' , vuelink : '/Contact/'},
				],
			}
		},
		methods : {
			gotop(){
				window.scrollTo(0,0)
			},
		}
	}
</script>

<style>
	ul{
     margin:0;
     border:0;
     padding:0;
}
	footer{
		position: relative;
		width: 100%;
		clear: both;
		background: url(../../static/img/footer.jpg) repeat;
		overflow: hidden;
	}
	.footer{
		margin: 0px auto;
		position: relative;
		clear: both;
		width: 1080px;
		padding: 28px 0 10px;
	}
	.footer-left{
		width: 100%;
		position: relative;
		clear: both;
		display: inline-block;
	}
	.left-li{
		position: relative;
		display: inline-block;
		width: 12.5%;
		vertical-align: top;
    color: #aaaaaa;
    text-align: center;
	}
	.left-li li{
		list-style: none;
		font-size: 12px;
		padding: 7.5px 0;
	}
	.footer-left h4{
		color: #fff;
		font-size: 14px;
		margin-bottom: 12.5px;
	}
	.left-li ul{
    -webkit-margin-before: 0em;
    -webkit-margin-after: 0em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 0px;
    -moz-margin-start: 0;
	-moz-margin-end: 0;
	-moz-padding-end: 0;
	-moz-padding-start: 0;
	}
	.left-li ul li a{
		text-decoration: none;
		color: #aaa;
	}
	.footer-line{
		border-left:1px solid #aaaaaa ;
		opacity: 0.3;
		height: 205px;
		position: absolute;
		display: inline-block;
		margin-left: 10px;
	}
	.footer-lines{
		border-bottom:1px solid #aaaaaa ;
		opacity: 0.3;
		height: 2px;
		width: 1080px;
		margin: 0 auto;
	}
	.footer-right{
		position: relative;
		display: inline-block;
		clear: both;
		width: 38%;
		top: 8px;
		left: 20px;
	}
	.right-img{
		width: 47%;
		display: inline-block;
		position: relative;
	    vertical-align: text-top;
	    text-align: left;
	    left: 13px;
	    margin-right: 9px;
	}
	.right-img img{
		width: 80px;
	}
	.right-tit{
		position: absolute;
		color: #FFFFFF;
		display: inline-block;
		margin-left: 10px;
		top: 20px;
		text-align: left;
		width: 300px;
	}
	.right-tit p{
		font-size: 12px;
	}
	.right-address{
		position: absolute;
	    clear: both;
	    display: inline-block;
	    width: 100%;
	    text-align: left;
	    top: 122px;
	    left: 13px;
	}
	.right-address p{
		color: #FFFFFF;
		font-size: 12px;
	}
	.footer-bottom{
		position: relative;
		clear: both;
		padding: 10px 0 30px;
		margin: 0 auto;
		width: 1080px;
	}
	.footer-bottom p{
		font-size: 12px;
		color: #AAAAAA;
	}
	.bottom-left{
		position: relative;
		display: inline-block;
		text-align: left;
		width: 50%;
		top: 5px;
	}
	.bottom-right{
		position: relative;
		display: inline-block;
		text-align: right;
		width: 48%;
		top: 10px;
		float: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue